import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "blueInfo",
  "use": "blueInfo-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"blueInfo\"><circle cx=\"8\" cy=\"8\" r=\"7\" fill=\"#031425\" /><path d=\"M8 4.5a.7.7 0 1 0 0 1.4.7.7 0 0 0 0-1.4zm-.007 2.442a.525.525 0 0 0-.517.533v3.85a.525.525 0 1 0 1.05 0v-3.85a.525.525 0 0 0-.533-.533z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol